module.exports = __webpack_public_path__ + "static/media/supportLogo3.8b47513a.png";